import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { clerkPlugin } from '@clerk/vue'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import * as Sentry from '@sentry/vue'
import { queryClient } from './api/queryClient'
import { routes, setupAuthGuard } from './router'
import App from './App.vue'
import './style.css'
import 'primeicons/primeicons.css'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

setupAuthGuard(router)

const pinia = createPinia()
const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0,
    sendDefaultPii: false,
  })
}

app.use(pinia)
app.use(router)
app.use(VueQueryPlugin, { queryClient })
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark',
    },
  },
})
app.use(ToastService)
app.use(clerkPlugin, {
  publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  routerPush: (to: string) => router.push(to),
  routerReplace: (to: string) => router.replace(to),
})

app.mount('#app')
